export default "__VITE_ASSET__90WB01dv__"